import React, { useContext, useState, FormEvent, useEffect } from "react";
import {
  Tab,
  Grid,
  Button,
  Table,
  Input,
  Form,
} from "semantic-ui-react";
import MobileStore from "../../../app/stores/mobileStore";
import { observer } from "mobx-react-lite";
import { IProjectDocument } from "../../../app/models/projectdocument";

const MobileArtifactsTab = () => {
  const mobileStore = useContext(MobileStore);
  const {
    project,
    createProjectDocuments,
    deleteProjectDocument,
    projectArtifactsByName,
    submitting,
    target,
  } = mobileStore;

  const initializeForm: IProjectDocument = {
    id: "",
    createdAt: "",
    updatedAt: "",
    projectId: project!.id,
    category: "Artifacts",
    fileName: "",
    fileType: "",
    fileSize: 0,
    description: "",
    previewUrl: "",
    downloadUrl: "",
    remark: "",
  };

  const [projectdocument, setProjectDocument] = useState<IProjectDocument>({
    id: "",
    createdAt: "",
    updatedAt: "",
    projectId: project!.id,
    category: "Artifacts",
    fileName: "",
    fileType: "",
    fileSize: 0,
    description: "",
    previewUrl: "",
    downloadUrl: "",
    remark: "",
  });

  const handleSubmit = () => {
    createProjectDocuments(projectdocument).then(() => setProjectDocument(initializeForm));;
  };

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setProjectDocument({ ...projectdocument, [name]: value });
  };

  const [show, setShow] = useState({
    id: '',
    status: false,
  })

  return (
    <Tab.Pane>
      <Button
                  as="a"
                    href='https://drive.google.com/drive/my-drive'
                    target="_Blank"
                    icon="google drive"
                    content='Google Drive'
                    color="blue"
                    title='Go to Google drive'
            />
            <p/>
      <Grid>
        <Grid.Column width={16}>
          <Form onSubmit={handleSubmit}>
            <Form.Group>
            <Form.Field inline>
                <label>File Name</label>
                <Input
                  onChange={handleInputChange}
                  name="fileName"
                  placeholder="File Name"
                  value={projectdocument.fileName}
                  style={{width: '150px'}}
                />
              </Form.Field>
              <Form.Field inline>
                <label>Description</label>
                <Input
                  onChange={handleInputChange}
                  name="description"
                  placeholder="Description"
                  value={projectdocument.description}
                />
              </Form.Field>
              <Form.Field inline>
                <label>Url</label>
                <Input
                  onChange={handleInputChange}
                  name="previewUrl"
                  placeholder="Url"
                  value={projectdocument.previewUrl}
                  style={{width: '400px'}}
                />
              </Form.Field>

              <Button
                loading={submitting}
                floated="right"
                positive
                type="submit"
                content="Add"
              />
            </Form.Group>
          </Form>
        </Grid.Column>
      </Grid>
      <Table>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width='4'>File Name</Table.HeaderCell>
            <Table.HeaderCell width='4'>Description</Table.HeaderCell>
            <Table.HeaderCell width='4'>Url</Table.HeaderCell>
            <Table.HeaderCell width='1'>Open</Table.HeaderCell>
            <Table.HeaderCell width='1'>Copy</Table.HeaderCell>
            <Table.HeaderCell width='1'>Action</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {projectArtifactsByName.map((projectdoc) => (
            <Table.Row key={projectdoc.id}>
              <Table.Cell>{projectdoc.fileName}</Table.Cell>
              <Table.Cell>{projectdoc.description}</Table.Cell>
              <Table.Cell>{projectdoc.previewUrl}</Table.Cell>
              <Table.Cell textAlign='center'>
                <Button
                   as="a"
                  href={`${projectdoc.previewUrl}`}
                  target="_Blank"
                   size='mini'
                   icon="folder open"
                   color="green"
                   title='Open link'
                 />
              </Table.Cell>
              <Table.Cell  textAlign='center'>
                 <Button
                    onClick={() => {navigator.clipboard.writeText(projectdoc.previewUrl); 
                      setShow({id: projectdoc.id, status: true});
                      setTimeout(() => {
                        setShow({id: projectdoc.id, status: false});
                      }, 3000);}}
                    size='mini'
                    icon="copy"
                    color="blue"
                    title='Copy link'
                  />
                  {(show.id === projectdoc.id) && (show.status === true) && <div>copied</div>}
              </Table.Cell>
              <Table.Cell  textAlign='center'>
              <Button
                name={projectdoc.id}
                size="mini"
                loading={target === projectdoc.id && submitting}
                onClick={(e) => deleteProjectDocument(e, projectdoc.id)}
                icon="delete"
                color="red"
                title="Delete"
              />
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </Tab.Pane>
  );
};

export default observer(MobileArtifactsTab);
